import { assert } from '@sama/js-core';
import { TRAINING_SHAPE_COLOR } from '../../../../../cross-team-shared/constants';
import { PointCloudContentState } from '../../../../state/point-cloud-content-state';
import { LineHelper } from './line-helper';

export class TrainingLineHelper extends LineHelper {
  override getPolyShapeName() {
    return `training-${super.getPolyShapeName()}`;
  }

  protected override getShapeState(state: PointCloudContentState) {
    const line = state.render.trainingShapes.lines[this.index];
    assert(line, 'line should exist');
    return line;
  }

  protected override getShapeColor(_state: PointCloudContentState) {
    return TRAINING_SHAPE_COLOR;
  }
}
